import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type FontScale = 'small' | 'normal' | 'large';

// Mnożniki dla root font-size (16px * mnożnik). MUI używa rem we wszystkich variantach
// typografii, więc zmiana html font-size kaskaduje do wszystkich tekstów + komponentów.
// Zakres ~90%–115% — kompromis między czytelnością a brakiem łamania layoutu.
export const FONT_SCALE_VALUE: Record<FontScale, number> = {
  small: 0.9,
  normal: 1.0,
  large: 1.15,
};

interface FontScaleState {
  scale: FontScale;
  setScale: (scale: FontScale) => void;
}

export const useFontScaleStore = create<FontScaleState>()(
  persist(
    (set) => ({
      scale: 'normal',
      setScale: (scale) => set({ scale }),
    }),
    { name: 'tms-font-scale' },
  ),
);
